import { render, staticRenderFns } from "./moveToDestructed.vue?vue&type=template&id=15019af5&scoped=true&"
import script from "./moveToDestructed.vue?vue&type=script&lang=js&"
export * from "./moveToDestructed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15019af5",
  null
  
)

export default component.exports